import { BigFormRow, FormSection } from 'framework/ui/layout';
import { Permission } from 'infrastructure/security/authorization/davinciAuthorizationService';
import { UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS } from 'domain/shared/employee';
import IdentityDocumentInput from 'domain/people/employee/shared/input/IdentityDocumentInput/IdentityDocumentInput';
import IdentityDocumentListInput from 'domain/people/employee/shared/input/IdentityDocumentInput/IdentityDocumentListInput';
import { FC } from 'react';

type IdentityDocUpdateSectionProps = {
  isGranted: (permission: Permission | Permission[], contextName?: string) => boolean;
};

const IdentityDocUpdateSection: FC<IdentityDocUpdateSectionProps> = ({ isGranted }) => {
  return (
    <FormSection title="Identifiers" isVisible={isGranted(UPDATE_EMPLOYEE_IDENTITY_DOCUMENTS)}>
      <BigFormRow>
        <IdentityDocumentListInput
          source="extendedInformation.identityDocuments"
          inputTemplate={IdentityDocumentInput}
          addText="Add document"
        />
      </BigFormRow>
    </FormSection>
  );
};

export { IdentityDocUpdateSection };
